import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';

import Careers from './Careers';
import Documentation from './Documentation';
import Security from './Security';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="/">
        Base13 Labs Limited
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  footer: {
      borderTop: `1px solid ${theme.palette.divider}`,
      marginTop: theme.spacing(8),
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      [theme.breakpoints.up('sm')]: {
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(6),
      },
    },
}));

export default function Footer() {
  const classes = useStyles();

  return (
      <Container maxWidth="md" component="footer" className={classes.footer}>
        <Grid container xs={12} sm={12} md={12} lg={12} spacing={4} justifyContent="space-evenly" >
          <Box padding={2}><Link href='/Careers' variant="subtitle1" color="textSecondary">Careers{'   '}</Link></Box>
          <Box padding={2}><Link href='/PrivacyPolicy' variant="subtitle1" color="textSecondary">Privacy policy{'   '}</Link></Box>
          <Box padding={2}><Link href='/TermsOfService' variant="subtitle1" color="textSecondary">Terms of service{'   '}</Link></Box>
          <Box padding={2}><Link href='https://www.linkedin.com/company/base13-labs/about/' variant="subtitle1" color="textSecondary" target="_blank"><Icon className="fab fa-linkedin" />{'   '}</Link></Box>
        </Grid>
        <Box mt={5}>
          <Copyright />
        </Box>
      </Container>
  );
}